import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4e141a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    src: _ctx.logoPath,
    class: _normalizeClass([{ 'link': _ctx.hasRoute }, "logo main-top-logo"]),
    alt: _ctx.logoAlt,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goTo && _ctx.goTo(...args))),
    ref: "logo"
  }, null, 10, _hoisted_1))
}